import { useState, useEffect } from 'react';
import { documenti as documentiApi } from '../../utils/api';

const TIPI = [
  { value: '',             label: 'Tutti i tipi' },
  { value: 'preventivo',   label: 'Preventivo' },
  { value: 'contratto',    label: 'Contratto' },
  { value: 'fattura',      label: 'Fattura' },
  { value: 'foto',         label: 'Foto' },
  { value: 'ddt',          label: 'DDT' },
  { value: 'bolla',        label: 'Bolla' },
  { value: 'certificato',  label: 'Certificato' },
  { value: 'collaudo',     label: 'Collaudo' },
  { value: 'planimetria',  label: 'Planimetria' },
  { value: 'sal',          label: 'SAL' },
  { value: 'computo',      label: 'Computo metrico' },
  { value: 'corrispondenza',label: 'Corrispondenza' },
  { value: 'pdf_generico', label: 'PDF generico' },
  { value: 'altro',        label: 'Altro' },
];

const PROVENIENZE = [
  { value: 'manuale',      label: 'Manuale' },
  { value: 'whatsapp',     label: 'WhatsApp' },
  { value: 'email',        label: 'Email' },
  { value: 'ai_generato',  label: 'AI' },
];

const PRESET_DATE = [
  { value: '',          label: 'Qualsiasi data' },
  { value: 'mese',      label: 'Questo mese' },
  { value: '3mesi',     label: 'Ultimi 3 mesi' },
  { value: 'anno',      label: "Quest'anno" },
  { value: 'custom',    label: 'Personalizzato' },
];

function getDateRange(preset) {
  var now = new Date();
  var da = null;
  var a = null;
  if (preset === 'mese') {
    da = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
  } else if (preset === '3mesi') {
    da = new Date(now.getFullYear(), now.getMonth() - 2, 1).toISOString().split('T')[0];
  } else if (preset === 'anno') {
    da = new Date(now.getFullYear(), 0, 1).toISOString().split('T')[0];
  }
  return { da: da, a: a };
}

export default function FiltriDocumenti({ filtri, onChange, hasArchivio }) {
  var [tags, setTags] = useState([]);
  var [loadingTags, setLoadingTags] = useState(false);
  var [datePreset, setDatePreset] = useState('');

  useEffect(function () {
    if (!hasArchivio) return;
    setLoadingTags(true);
    documentiApi.getTag()
      .then(function (r) { setTags(r.data.results || r.data || []); })
      .catch(function () {})
      .finally(function () { setLoadingTags(false); });
  }, [hasArchivio]);

  var selSty = {
    padding: '7px 10px', borderRadius: 'var(--radius-base)',
    border: '1px solid var(--ds-border)', fontSize: 12,
    outline: 'none', fontFamily: 'inherit',
    background: 'var(--ds-bg)', color: 'var(--ds-text)',
    cursor: 'pointer',
  };

  var pillBase = {
    padding: '10px 14px', borderRadius: 99, fontSize: 11, fontWeight: 500,
    border: '1px solid var(--ds-border)', cursor: 'pointer',
    transition: 'all 0.15s',
  };

  var handleDatePreset = function (preset) {
    setDatePreset(preset);
    if (preset === 'custom') return;
    var range = getDateRange(preset);
    onChange({ data_documento_da: range.da || '', data_documento_a: range.a || '' });
  };

  var handleProvenienza = function (val) {
    var current = filtri.provenienza || '';
    onChange({ provenienza: current === val ? '' : val });
  };

  var handleTag = function (tagId) {
    var current = filtri.tag || '';
    onChange({ tag: current === tagId ? '' : tagId });
  };

  var hasAnyFilter = filtri.tipo || filtri.provenienza || filtri.tag || filtri.data_documento_da || filtri.data_documento_a;

  var handleReset = function () {
    setDatePreset('');
    onChange({ tipo: '', provenienza: '', tag: '', data_documento_da: '', data_documento_a: '' });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {/* Row 1: tipo + data preset */}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
        <select style={selSty} value={filtri.tipo || ''} onChange={function (e) { onChange({ tipo: e.target.value }); }}>
          {TIPI.map(function (t) { return <option key={t.value} value={t.value}>{t.label}</option>; })}
        </select>

        <select style={selSty} value={datePreset} onChange={function (e) { handleDatePreset(e.target.value); }}>
          {PRESET_DATE.map(function (p) { return <option key={p.value} value={p.value}>{p.label}</option>; })}
        </select>

        {datePreset === 'custom' && (
          <>
            <input
              type="date"
              value={filtri.data_documento_da || ''}
              onChange={function (e) { onChange({ data_documento_da: e.target.value }); }}
              style={{ ...selSty, minWidth: 130 }}
            />
            <span style={{ fontSize: 12, color: 'var(--ds-muted)' }}>-</span>
            <input
              type="date"
              value={filtri.data_documento_a || ''}
              onChange={function (e) { onChange({ data_documento_a: e.target.value }); }}
              style={{ ...selSty, minWidth: 130 }}
            />
          </>
        )}

        {hasAnyFilter && (
          <button
            onClick={handleReset}
            style={{ ...selSty, border: 'none', background: 'transparent', color: 'var(--ds-danger)', fontWeight: 500, padding: '7px 8px' }}
          >
            Azzera filtri
          </button>
        )}
      </div>

      {/* Row 2: provenienza pills */}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
        <span style={{ fontSize: 10, fontWeight: 500, color: 'var(--ds-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginRight: 4 }}>Provenienza</span>
        {PROVENIENZE.map(function (p) {
          var active = filtri.provenienza === p.value;
          return (
            <button
              key={p.value}
              onClick={function () { handleProvenienza(p.value); }}
              style={{
                ...pillBase,
                background: active ? 'var(--brand)' : 'var(--ds-bg)',
                color: active ? '#fff' : 'var(--ds-text)',
                borderColor: active ? 'var(--brand)' : 'var(--ds-border)',
              }}
            >
              {p.label}
            </button>
          );
        })}
      </div>

      {/* Row 3: tag pills */}
      {hasArchivio && tags.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ fontSize: 10, fontWeight: 500, color: 'var(--ds-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginRight: 4 }}>Tag</span>
          {tags.map(function (t) {
            var active = filtri.tag === String(t.id);
            var tagColor = t.colore || 'var(--ds-muted)';
            return (
              <button
                key={t.id}
                onClick={function () { handleTag(String(t.id)); }}
                style={{
                  ...pillBase,
                  background: active ? tagColor : 'var(--ds-bg)',
                  color: active ? '#fff' : tagColor,
                  borderColor: active ? tagColor : 'var(--ds-border)',
                }}
              >
                {t.nome}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
